import styled from 'styled-components';

const CheckboxCell = styled.div`
  [data-theme='MozartCheckBox'] {
    input[type='checkbox']:disabled + label {
      cursor: not-allowed;
    }

    label::before {
      top: -15px !important;
    }
  }
`;

export default CheckboxCell;
